import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  SelectInput,
  ReferenceInput,
  ListProps,
} from 'react-admin'

const MarksFilter = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="q" alwaysOn />
      <ReferenceInput label="" source="" reference="" allowEmpty>
        <SelectInput optionText="name" />
      </ReferenceInput>
    </Filter>
  )
}

export const ListMarks: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      // filters={<MarksFilter />}
      {...rest}
      data-testid="list"
    >
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" />
        <TextField label="Texto" source="text" />
        <TextField label="Cor" source="color" />
        <TextField label="Cor padrão" source="default_color" />
        <TextField label="Cor do texto" source="text_color" />
        <TextField label="Alinhamento" source="direction_text" />
        <TextField label="Tipo" source="type" />
      </Datagrid>
    </List>
  )
}
